import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { PartnerWidget } from 'widgets/partner/PartnerWidget';

export const PartnerPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Партнеры'));
    dispatch(setHeaderAction('create'));
    dispatch(setActionBtnTitle('Создать'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <PartnerWidget />;
};
